module.exports = __webpack_public_path__ + "img/1.c00b9884.jpg";